export default async ({ store }) => {
	if (!store.state.links) {
		await store.dispatch('loadLinks');
	}
}